module.exports = __webpack_public_path__ + "static/media/Bicocca - white_Violet.a0c346d3.jpg";